import script from "./GiaThanhSuaChuaCacCapPrintTemplate.vue?vue&type=script&lang=ts&setup=true"
export * from "./GiaThanhSuaChuaCacCapPrintTemplate.vue?vue&type=script&lang=ts&setup=true"

import "./GiaThanhSuaChuaCacCapPrintTemplate.vue?vue&type=style&index=0&id=8500d0fe&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8500d0fe"]])

export default __exports__